// externals
import { dealerSelectors } from '@makemydeal/dr-shared-store';
import type { FC } from 'react';
import { useSelector } from 'react-redux';

// components
import { RemoteModuleErrorBoundaryBase } from './RemoteModuleErrorBoundaryBase';

// types
import type { RemoteModuleErrorBoundaryProps } from '../../types';

/**
 * Store-connected wrapper around {@link RemoteModuleErrorBoundaryBase} — the boundary hosts should
 * render when wrapping a Common Consumer Card remote module.
 *
 * Its only job is to read the dealer id from Redux and hand it to the boundary class, which needs
 * it as a New Relic attribute but cannot use hooks itself. Keeping that lookup here means hosts
 * don't each have to plumb `dealerId` through.
 */
export const RemoteModuleErrorBoundary: FC<RemoteModuleErrorBoundaryProps> = (props) => (
    <RemoteModuleErrorBoundaryBase {...props} dealerId={String(useSelector(dealerSelectors.getDealerId))} />
);

export default RemoteModuleErrorBoundary;
